<template>
	<div>
		<FiltersButton
			:filters="activeFilters"
			:show-count="showFiltersCount"
			:show-label="false"
			@click="openFiltersList"
		/>
		<FiltersList
			v-if="isFiltersListOpen"
			:title="title"
			:is-open="isFiltersListOpen"
			:open-into="openInto"
			:module-name="moduleName"
			:search-keyword="searchKeyword"
			@close="closeFiltersList"
			@filters-updated="handleFiltersUpdated"
		/>
	</div>
</template>

<script>
import FiltersButton from './FiltersButton';
import FiltersList from './FiltersList';
import { mapGetters } from 'vuex';

export default {
	name:       'ClipFilters',
	components: { FiltersList, FiltersButton },
	props:      {
		title: {
			type: String,
		},
		openInto: {
			type: [Object, null],
		},
		moduleName: {
			type:    String,
			default: 'clipFilters',
		},
		showFiltersCount: {
			type:    Boolean,
			default: true,
		},
		searchKeyword: {
			type: String,
		},
	},
	data() {
		return {
	  		isFiltersListOpen: false,
		};
	},
	computed: {
	  ...mapGetters({
			tags: 'event/tags',
		}),
		activeFilters() {
			return this.$store.getters[`${this.moduleName}/activeFilters`];
		},
	},
	methods: {
		openFiltersList() {
	    	this.isFiltersListOpen = true;
		},
		closeFiltersList() {
	    	this.isFiltersListOpen = false;
		},
		handleFiltersUpdated(activeFilters) {
			this.$emit('filters-updated', activeFilters, this.moduleName);
		},
	},
};
</script>

<style scoped>

</style>
